// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.F2uNn{display:flex;flex-direction:column;gap:24px}.hWd0c{display:flex;flex-direction:row;gap:16px}.H4upM{margin:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"serviceBillingCell": `F2uNn`,
	"row": `hWd0c`,
	"stages": `H4upM`
};
export default ___CSS_LOADER_EXPORT___;
